import React from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Box, Card, CardContent, Container } from "@mui/material";
import ContactImage from "../../../../assets/images/contact_us.png";
import Grid from "@mui/material/Grid2";

const FAQCard = ({ question, answer, isOpen, onClick }) => {
  return (
    <Card className="mb-4 border-none shadow-sm hover:shadow-md transition-shadow duration-200">
      <button
        onClick={onClick}
        className="w-full text-left px-6 py-4 flex justify-between items-center"
      >
        <p className="text-md font-medium">{question}</p>
        <MdKeyboardArrowDown
          className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
          isOpen ? "max-h-48" : "max-h-0"
        }`}
      >
        <CardContent className="px-6 pb-4 pt-0 text-gray-600">
          {answer}
        </CardContent>
      </div>
    </Card>
  );
};

const FAQs = () => {
  const [openPanel, setOpenPanel] = React.useState("panel1");

  const faqData = [
    {
      panel: "panel1",
      question: "What are the requirements for Undergraduate Admission?",
      answer:
        "International passport, High school transcript, WAEC, WAEC scratch card, English proficiency test results (if applicable), and Motivational letter (provided by RENPHA).",
    },
    {
      panel: "panel2",
      question: "What are the requirements for Postgraduate Admission?",
      answer:
        "International passport, Degree certificate, Transcript, CV, Reference letter, WAEC, English proficiency test results (if applicable), and Motivational letter (provided by RENPHA).",
    },
    {
      panel: "panel3",
      question: "What are the visa requirements for studying abroad?",
      answer:
        "Undergraduate: International passport, Passport photo, Admission letter, 6 months’ bank statement, Work details, and English proficiency test results (if applicable). Postgraduate: Includes the above plus CV and acceptance letter.",
    },
    {
      panel: "panel4",
      question: "Do I need to pay tuition before applying for a visa?",
      answer:
        "Yes, most schools require a deposit after admission. The proof of payment is needed for visa processing.",
    },
    {
      panel: "panel5",
      question: "Can I work while studying and after graduation?",
      answer:
        "Yes, part-time during studies and full-time during breaks. Staying back after graduation depends on job placement opportunities.",
    },
    {
      panel: "panel6",
      question: "Do I need to write an English proficiency test (IELTS/TOEFL)?",
      answer:
        "It depends on the university's requirements. RENPHA will advise if it's mandatory.",
    },
    {
      panel: "panel7",
      question: "What is the average tuition fee for studying abroad?",
      answer:
        "USA: $16,757–$43,065 annually. Canada: CA$14,000 upwards. UK: £15,000–£35,000 annually.",
    },
  ];

  return (
    <Container>
      <Grid
        container
        spacing={2}
        sx={{
          flexDirection: { xs: "column-reverse", md: "row" },
          alignItems: "center",
        }}
      >
        <Grid item size={{ xs: 12, md: 4 }} mb={4}>
          <Box display="flex" flexDirection="column" justifyContent="center">
            <img
              src={ContactImage}
              alt="Contact Us"
              style={{
                width: "100%",
                maxWidth: "350px",
                borderRadius: "12px",
              }}
            />
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 8 }} mb={4}>
          <div className="text-center ">
            <h2 className="text-4xl font-bold text-gray-900 ">
              Frequently Asked Questions
            </h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>
          </div>
          <div className=" space-y-2">
            {faqData.map((item) => (
              <FAQCard
                key={item.panel}
                question={item.question}
                answer={item.answer}
                isOpen={openPanel === item.panel}
                onClick={() =>
                  setOpenPanel(openPanel === item.panel ? "" : item.panel)
                }
              />
            ))}
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FAQs;
